<template>
  <v-container>
    <v-card max-width="500" class="mx-auto">
      <v-card-title>
        Relatórios
      </v-card-title>

      <v-list>
        <v-list-item
          :to="{ name: 'locacoes_relatorios_pagamentos_recebidos' }"
          link
        >
          <v-list-item-content>
            <v-list-item-title>
              Pagamentos recebidos por período
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {}
};
</script>
